import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import FormTablesLayer from '../components/FormTablesLayer';

const FormTablesPage = () => (
  <MasterLayout pageTitle='Form Reference Tables'>
    <FormTablesLayer />
  </MasterLayout>
);

export default FormTablesPage;
